import { action, atom, reaction } from '@reatom/framework'
import { withLocalStorage } from '@reatom/persist-web-storage'

import { pipe, Record } from '@blade/std-lib'
import { Network, selectedNetworkAtom } from '@root/entities/network'
import { walletsAtom } from '@root/entities/wallet'
import { STORAGE_PREFIX } from '@root/shared'

import type { WalletId } from '@root/entities/wallet'

type WalletByNetwork = Record<Network.Network, WalletId | undefined>

const init: WalletByNetwork = Network.byNetworkRecord(() => undefined)

export const tradingWalletsByNetworkAtom = atom<WalletByNetwork>(
  init,
  'tradingWalletsByNetworkAtom',
).pipe(withLocalStorage(`${STORAGE_PREFIX}/v1/tradingWalletsByNetwork`))

const selectedTradingWalletId = atom((ctx) => {
  const network = ctx.spy(selectedNetworkAtom)
  const tradingWalletsByNetwork = ctx.spy(tradingWalletsByNetworkAtom)
  return tradingWalletsByNetwork[network]
}, 'selectedTradingWalletId')

export const tradingWalletAtom = atom((ctx) => {
  const walletId = ctx.spy(selectedTradingWalletId)
  const wallets = ctx.spy(walletsAtom)

  return wallets.find((it) => it.id === walletId) ?? wallets.at(0)
}, 'tradingWalletAtom')

export const tradingWalletIdAtom = atom(
  (ctx) => ctx.spy(tradingWalletAtom)?.id,
  'tradingWalletIdAtom',
)
export const tradingWalletAddressAtom = atom(
  (ctx) => ctx.spy(tradingWalletAtom)?.address,
  'tradingWalletAddressAtom',
)
export const hasTradingWalletAtom = atom(
  (ctx) => ctx.spy(tradingWalletAtom) !== undefined,
  'hasTradingWalletAtom',
)

export const setTradingWalletAction = action((ctx, id: WalletId) => {
  const network = ctx.get(selectedNetworkAtom)
  tradingWalletsByNetworkAtom(ctx, (it) => pipe(it, Record.set(network, id)))
}, 'setTradingWalletAction')

const syncReaction = reaction((ctx) => {
  const tradingWallet = ctx.spy(tradingWalletAtom)
  if (!tradingWallet) {
    return
  }

  const tradingWalletsByNetwork = ctx.get(tradingWalletsByNetworkAtom)
  const selectedWalletId = tradingWalletsByNetwork[tradingWallet.network]

  if (selectedWalletId !== tradingWallet.id) {
    setTradingWalletAction(ctx, tradingWallet.id)
  }
}, 'syncReaction')

export const initializeTradingWalletAction = action((ctx) => {
  syncReaction(ctx)
}, 'initializeTradingWalletAction')
